<template>
    <div class="wrapper">
        <h1 class="crumb">新增</h1>
        <!--<el-row style="text-align: center;margin-bottom: 30px;color: #ea6625">-->
            <!--<el-col :span="7">新订单</el-col>-->
            <!--<el-col :span="7">预约分类</el-col>-->
            <!--<el-col :span="7">待处理分类 </el-col>-->
        <!--</el-row>-->
        <h3 style="color: #ea6625">新订单</h3>
        <el-table
            :data="orderList"
            style="margin-top: 30px"
        >
            <el-table-column label="订单号" prop="order_sn" align="center" show-overflow-tooltip="true"></el-table-column>
            <el-table-column label="合同订单号" prop="contract_number" align="center" show-overflow-tooltip="true"></el-table-column>
            <el-table-column label="订单来源" prop="referer" align="center" show-overflow-tooltip="true"></el-table-column>
        </el-table>
        <!--<h3 style="color: #ea6625;margin-top: 20px">已预约</h3>-->
        <!--<el-table-->
            <!--:data="yuyueList"-->
            <!--style="margin-top: 30px"-->
        <!--&gt;-->
            <!--&lt;!&ndash;<el-table-column label="订单号" prop="order_sn" align="center" show-overflow-tooltip="true"></el-table-column>&ndash;&gt;-->
            <!--<el-table-column label="合同订单号" prop="contract_number" align="center" show-overflow-tooltip="true"></el-table-column>-->
            <!--<el-table-column label="预约日期" prop="yuyue_time" align="center" show-overflow-tooltip="true"></el-table-column>-->
            <!--<el-table-column label="订单来源" prop="referer" align="center" show-overflow-tooltip="true"></el-table-column>-->
        <!--</el-table>-->
        <!--<h3 style="color: #ea6625;margin-top: 20px">待下派</h3>-->
        <!--<el-table-->
            <!--:data="orderList"-->
            <!--style="margin-top: 30px"-->
        <!--&gt;-->
            <!--<el-table-column label="订单号" prop="order_sn" align="center" show-overflow-tooltip="true"></el-table-column>-->
            <!--<el-table-column label="合同订单号" prop="contract_number" align="center" show-overflow-tooltip="true"></el-table-column>-->
            <!--<el-table-column label="订单来源" prop="referer" align="center" show-overflow-tooltip="true"></el-table-column>-->
        <!--</el-table>-->
    </div>
</template>
<script>
        import ElRow from "element-ui/packages/row/src/row";

        export default {
            components: {ElRow},
            data() {
                return {
                    orderList: [],
                    yuyueList: [],
                    daichuliList: [],
                }
            },
            created () {
                this.getData()
            },
            methods: {
                getData () {
                    this.$http.get(this.$reqUrl + `service.php?act=default&session_id=${localStorage.getItem('shouhou_session_id')}`).then(res => {
                        this.orderList = res.data.order
                        this.yuyueList = res.data.yuyue
                        this.daichuliList = res.data.deal
                    })
                }
            }
        }
</script>
<style lang="less">
    .wrapper{
        .bar {
            display: flex;
            justify-content: space-between;
            margin-bottom: 15px;
            button {
                width: 100Px;
                height: 37Px;
                margin-right: 10Px;
                font-size: 16px;
                color: #ffffff;
                background: #f56c31;
                border-radius: 2px;
            }
        }
    }
</style>
<style>
    .el-table th>.cell{
        color:#ea6625;
    }
    .el-table td, .el-table th{
        padding: 0;
        height: 50px;
        line-height: 50px;
    }
</style>



// WEBPACK FOOTER //
// src/router/Defuil.vue